import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next"
import { Container, Button, Row, Form, Col } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import useAuth from '../../../context/auth/useAuth'
import { getUser, editUser } from '../../../actions/profiles/usersActions'

export default function Config() {
    const { t } = useTranslation()
	const {clientauth} = useAuth()
    const dispatch = useDispatch()

    const {user, resultuser} = useSelector(state=>state.users)

    const [isUpdating, setIslogging] = useState(false)
    const [formState, setFormState] = useState({})
    const [passwordverify, setPasswordverify] = useState("")

    const [showPasswordOne, setShowPasswordOne] = useState(false)
    const [showPasswordTwo, setShowPasswordTwo] = useState(false)

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        })
        if(clientauth){
            dispatch(getUser(clientauth?.id))
        }
    },[dispatch, t, clientauth])

    useEffect(() => {
        if(user){
            setFormState({
                username: user?.username,
                email: user?.email,
                password: '',
            })
        }
    // eslint-disable-next-line
    }, [user, user])

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handlePasswordVisibilityOne = () => {
        setShowPasswordOne(!showPasswordOne)
    }

    const handlePasswordVisibilityTwo = () => {
        setShowPasswordTwo(!showPasswordTwo)
    }

    const checkValidation = (isPassVer, e) => {
        const confirmPass = e.target.value

        if(isPassVer){
            setPasswordverify(confirmPass)
        }else{
            setFormState({
                ...formState,
                'password': confirmPass
            })
        }
    }

    const handleEdit = async(e) => {
        e.preventDefault()
        setIslogging(true)
        if(formState.password === passwordverify || formState.password === ''){
            if((formState.password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,8}$/g) && formState.password === passwordverify) || formState.password === ''){
                dispatch(editUser(formState, clientauth?.id))
            }else{
                Swal.fire({
                    showConfirmButton: true,
                    icon: 'warning',
                    text: t('users.passwordsnotvalid')
                })
            }
        }else{
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('users.passwordsnotmatch')
            })
        }
        setIslogging(false)
    }

    useEffect(() => {
        if(resultuser){
            let newresult = resultuser
            dispatch({
                type: 'USER_RESET_RESULT'
            })
            switch (newresult) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'success',
                        text: t('users.useredited')
                    })
                    break;
                case 'email':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('users.emailduplicate')
                    })
                    break;
                case 'username':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('users.usernameduplicate')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultuser])

    return (
        <Container className='cuerpo'>
            <div className="page-header">
                <h1>{t('users.editaccount')}</h1>
                <p className="page-subtitle">{t('config.subtitle') || 'Actualiza tu información personal'}</p>
            </div>
            <Row className="justify-content-center">
                <Col xs={12} lg={8}>
                    <div className='config-card'>
                        <div className='config-card-header'>
                            <div className='config-card-icon'>
                                <i className="fas fa-user-edit"></i>
                            </div>
                            <div>
                                <h3>{t('users.personalInfo') || 'Información personal'}</h3>
                                <p>{t('config.personalInfoDesc') || 'Actualiza tu email y nombre de usuario'}</p>
                            </div>
                        </div>
                        <Form className="formulario" onSubmit={handleEdit}>
                            <Row className="mb-3">
                                <Col md={6}>
                                    <Form.Group className='form-group'>
                                        <Form.Control
                                            className={formState.username ? 'has-content' : ''}
                                            type='text'
                                            name='username'
                                            value={formState.username ||  ''}
                                            onChange={handleInputChange}
                                            required
                                        />
                                        <Form.Label>{t('users.username')}</Form.Label>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className='form-group'>
                                        <Form.Control
                                            className={formState.email ? 'has-content' : ''}
                                            type='email'
                                            name='email'
                                            value={formState.email ||  ''}
                                            onChange={handleInputChange}
                                        />
                                        <Form.Label>{t('users.email')}</Form.Label>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <div className='config-divider'></div>

                            <div className='config-card-header' style={{marginBottom: 20}}>
                                <div className='config-card-icon navy'>
                                    <i className="fas fa-lock"></i>
                                </div>
                                <div>
                                    <h3>{t('users.password')}</h3>
                                    <p>{t('config.passwordDesc') || 'Cambia tu contraseña (opcional)'}</p>
                                </div>
                            </div>

                            <Row className="mb-3">
                                <Col md={6} className='sd-passwordview'>
                                    <Form.Group className='form-group'>
                                        <Form.Control
                                            className={formState.password ? 'has-content' : ''}
                                            type={showPasswordOne ? 'text' : 'password'}
                                            name='password'
                                            value={formState.password ||  ''}
                                            placeholder=' '
                                            onChange={(e) => checkValidation(false, e)}
                                        />
                                        <Form.Label>{t('users.newpassword')}</Form.Label>
                                        <img className="sd-imageneye" src={showPasswordOne ? "/images/eyeclose.svg" : "/images/eyeopen.svg"} alt="eyes" width={15} onClick={handlePasswordVisibilityOne} />
                                    </Form.Group>
                                </Col>
                                <Col md={6} className='sd-passwordview'>
                                    <Form.Group className='form-group'>
                                        <Form.Control
                                            className='has-content'
                                            type={showPasswordTwo ? 'text' : 'password'}
                                            name='passwordcheck'
                                            placeholder=' '
                                            onChange={(e) => checkValidation(true, e)}
                                        />
                                        <Form.Label>{t('users.passwordconfirm')}</Form.Label>
                                        <img className="sd-imageneye" src={showPasswordTwo ? "/images/eyeclose.svg" : "/images/eyeopen.svg"} alt="eyes" width={15} onClick={handlePasswordVisibilityTwo}></img>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <p className='password-requirements'>
                                <span className='fs-12 fw-400'>{t('users.passwordneed1')}</span><br/>
                                <span className='password-list'>
                                    <span className='fs-12 fw-400'><b>·</b> {t('users.passwordneed2')}</span>
                                    <span className='fs-12 fw-400'><b>·</b> {t('users.passwordneed3')}</span>
                                    <span className='fs-12 fw-400'><b>·</b> {t('users.passwordneed4')}</span>
                                </span>
                            </p>

                            <div className='config-actions'>
                                <Button variant='primary' type="submit" className="btn-save">
                                    {isUpdating
                                        ? <span className="spinner-border spinner-border-sm align-middle"></span>
                                        : <><i className="fas fa-check"></i> {t('global.update')}</>
                                    }
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}
